const DEFAULTS = {
  panelSelector: '[data-comp-accordion-panel]',
  buttonSelector: '[data-comp-accordion-button]',
  contentSelector: '[data-comp-accordion-content]',
};

export default function initAccessibleAccordions() {
  const panels = document.querySelectorAll(DEFAULTS.panelSelector);

  if (panels.length === 0) {
    return;
  }

  panels.forEach((panel) => {
    const content = panel.querySelector(DEFAULTS.contentSelector);
    const button = panel.querySelector(DEFAULTS.buttonSelector);

    const closeOtherAccordions = () => {
      panels.forEach((panelItem) => {
        const contentItem = panelItem.querySelector(DEFAULTS.contentSelector);
        const buttonItem = panelItem.querySelector(DEFAULTS.buttonSelector);

        if (contentItem !== content) {
          contentItem.setAttribute('aria-hidden', 'true');
          contentItem.setAttribute('inert', '');
          buttonItem.setAttribute('aria-expanded', 'false');
        }
      });
    };

    const handleAccordion = () => {
      closeOtherAccordions();

      if (content) {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', !isExpanded);
        content.setAttribute('aria-hidden', isExpanded);
        !isExpanded
          ? content.removeAttribute('inert')
          : content.setAttribute('inert', '');
      }
    };

    if (button) {
      button.addEventListener('click', () => {
        handleAccordion();
      });

      button.addEventListener('keydown', (e) => {
        if (e.code === 'Enter' || e.code === 'Space') {
          e.preventDefault();
          handleAccordion();
        }
      });
    }
  });
}
